
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  projectNewFormButton: {
    id: "ProjectNewFormButton.button",
    defaultMessage: "Create project",
  },
  projectNameError: {
    id: "ProjectName.error",
    defaultMessage: "Name is required.",
  },
  projectName: {
    id: "ProjectName.name",
    defaultMessage: "Object name:",
  },
  buildingNumberError: {
    id: "BuildingNumber.error",
    defaultMessage: "Building number is required.",
  },
  buildingNumber: {
    id: "BuildingNumber.number",
    defaultMessage: "Building number (CRM)",
  },
  opportunityNumberError: {
    id: "OpportunityNumber.error",
    defaultMessage: "Opportunity number is required.",
  },
  opportunityNumber: {
    id: "OpportunityNumber.number",
    defaultMessage: "Opportunity number (CRM)",
  },
  projectStreetError: {
    id: "ProjectStreet.error",
    defaultMessage: "Street is required and should contain at least 2 characters.",
  },
  projectStreet: {
    id: "ProjectStreet.name",
    defaultMessage: "Street",
  },
  projectStreetNrError: {
    id: "ProjectStreetNr.error",
    defaultMessage: "No. is required and should contain at least 1 characters.",
  },
  projectStreetNr: {
    id: "ProjectStreetNr.name",
    defaultMessage: "No.",
  },
  projectZipError: {
    id: "ProjectZip.error",
    defaultMessage: "Zip is required and should contain at least 2 characters.",
  },
  projectZip: {
    id: "ProjectZip.name",
    defaultMessage: "Zip",
  },
  projectCityError: {
    id: "ProjectCity.error",
    defaultMessage: "City is required and should contain at least 2 characters.",
  },
  projectCity: {
    id: "ProjectCity.name",
    defaultMessage: "City",
  },
  projectCountryError: {
    id: "ProjectCountry.error",
    defaultMessage: "Country is required.",
  },
  projectCountry: {
    id: "ProjectCountry.name",
    defaultMessage: "Country",
  },
  projectCountryLabel: {
    id: "ProjectCountry.label",
    defaultMessage: "Choose country",
  },
  connectedFolder: {
    id: "ConnectedFolder.label",
    defaultMessage: "Yes, I would like to create a new folder with the object name in my dashboard.",
  },
});

export default MESSAGES;